import React, { useEffect, useRef, useState } from 'react';


import { useTranslation } from 'react-i18next';

import AuthService from '../security/AuthService';
import { Button } from 'primereact/button';
import { useNavigate, useParams } from 'react-router-dom';
import eventBus from '../common/EventBus';
import ProfileService from '../service/ProfileService';
import EventBus from "../common/EventBus";
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import Constants from '../constants/Constants';
import ExhibitionService from '../service/ExhibitionService';
import FavoriteService from '../service/FavoriteService';
import CustomFeaturedExhibitions from './CustomFeaturedExhibitions';


export const CustomFeaturedSelectExhibit = (props) => {
    const { t } = useTranslation();
    const toast = useRef(null);
    const navigate = useNavigate();


    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);


    const [exhibits, setExhibits] = useState([]);
    const [status, setStatus] = useState(Constants.exhibitionStatus.own);

    useEffect(() => {
        loadFeaturedExhibits(status);
    }, []);



    const loadFeaturedExhibits = async (param) => {
        setDisplayLoadingDialog(true);
        setExhibits([]);
        ExhibitionService.inquireFeaturedExhibitsByFilterType( param).then(
            (response) => {
                console.log("inquireFeaturedExhibitsByFilterType", response)
                console.log("inquireFeaturedExhibitsByFilterType", response?.data?.data?.dataList)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireFeaturedExhibitsByFilterType", response?.data?.data?.dataList)
                    setExhibits(response?.data?.data?.dataList);
                }
                setDisplayLoadingDialog(false);
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireExhibitByStatus logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );

    }



  

    const onStatusChange = (param) => {

        setStatus(param);
        loadFeaturedExhibits(param);
    }

    const onSelectedExhibit = (param) => {
        console.log("onSelectedExhibit", param)
        props.onSetFeaturedExhibit(param);
    }




    return (
        <div className='surface-featuredexhibit-header'>
            <Toast ref={toast} />
            <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                <div>
                    <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                    </img>
                </div>
            </Dialog>
            <div style={{}}>
                <span className="block text-4xl  mb-1  p-2">
                    {t('featured_exhibitions')}
                </span>
                <div style={{
                    flexDirection: 'row',
                    display: 'flex',
                    //   justifyContent: 'space-between',
                    padding: 10,
                }}
                >
                    <Button className={status === Constants.featuredExhibitionFilter.favorites ? "p-button-rounded mr-2 mb-2" : "p-button-rounded p-button-gray mr-2 mb-2"} label={t("featured_exhibitions_favorites")}
                        onClick={() => onStatusChange(Constants.featuredExhibitionFilter.favorites)} />

                    <Button className={status === Constants.featuredExhibitionFilter.attended ? "p-button-rounded mr-2 mb-2" : "p-button-rounded p-button-gray mr-2 mb-2"} label={t("featured_exhibitions_attended")}
                        onClick={() => onStatusChange(Constants.featuredExhibitionFilter.attended)} />

                    <Button className={status === Constants.featuredExhibitionFilter.own ? "p-button-rounded mr-2 mb-2" : "p-button-rounded p-button-gray mr-2 mb-2"} label={t("featured_exhibitions_own")}
                        onClick={() => onStatusChange(Constants.featuredExhibitionFilter.own)} />

                </div>
            </div>
            <CustomFeaturedExhibitions hasAction={true} exhibits={exhibits} labelStyle={{ color: "#000000" }}  onSelectedExhibit={onSelectedExhibit}></CustomFeaturedExhibitions>
        </div >
    );
};

export default CustomFeaturedSelectExhibit;
